const TMP_HEADER = process.env.REACT_APP_TMP_HEADER;

export const tmpHeader = () => {
  return { tmpauth: TMP_HEADER };
};